import { captureMessage } from "@sentry/nextjs";
import { isChannel } from "@website/utils/channel/helpers";
import {
  NewPasswordCard,
  OtpCard,
  PasswordCard,
  PasswordChangeSuccessfulCard,
  PhoneNumberCard
} from "@website/widget/login/components";
import styles from "@website/widget/login/login.module.scss";
import {
  LoginPropertiesType,
  LoginStepType
} from "@website/widget/login/login.types";
import { useLogin } from "@website/widget/login/use-login";
import { FC, memo, useCallback, useEffect } from "react";

const Login: FC<LoginPropertiesType> = (properties) => {
  const { onEndAuth, onClose } = properties;
  const { step, setStep, userData, setUserData } = useLogin();

  const setStepHandler = useCallback(
    (step: LoginStepType) => {
      setStep(step);
    },
    [setStep]
  );

  useEffect(() => {
    const isB2b = isChannel(["b2b"]);
    if (isB2b) {
      captureMessage("B2C login modal is open inside B2B", {
        level: "log",
        extra: {
          url: window.location.href,
          referrer: document.referrer
        }
      });
    }
  }, []);

  return (
    <div className={styles["container"]}>
      {step === "phone-number" && (
        <PhoneNumberCard
          onClose={onClose}
          setStep={setStepHandler}
          setUserData={setUserData}
          userData={userData}
        />
      )}
      {step === "otp" && (
        <OtpCard
          onClose={onClose}
          onEndAuth={onEndAuth}
          setStep={setStepHandler}
          setUserData={setUserData}
          userData={userData}
        />
      )}
      {step === "password" && (
        <PasswordCard
          onClose={onClose}
          onEndAuth={onEndAuth}
          setStep={setStepHandler}
          setUserData={setUserData}
          userData={userData}
        />
      )}
      {step === "forgot-password" && (
        <NewPasswordCard
          onEndAuth={onEndAuth}
          setStep={setStepHandler}
          userData={userData}
        />
      )}
      {step === "password-change-successful" && (
        <PasswordChangeSuccessfulCard />
      )}
    </div>
  );
};

const LoginMemoized = memo(Login);
export { LoginMemoized as Login };
